import layout from './layout';
import pages from './pages';
import accountManagers from './accountManagers';


export default [
  layout,
  pages,
  accountManagers
];